import { FlightEventHandler } from "./flight"
import { writable } from "svelte/store"

export default class RoamEvents extends FlightEventHandler {
	roams = []

	constructor(flight) {
		super(flight)

		const w = writable([])

		this.subscribe = w.subscribe
		this.update = w.update
		this.set = w.set
	}

	handleKeyframe(kf) {
		if (this.roams && this.roams.length) return
		this.roams = JSON.parse(JSON.stringify(kf.roams))
		this.set(this.roams)
	}

	handleFlightHistoryAppend(message) {
		if (message.type === 'LINK_ROAM') {
			this.roams.push(message)
			this.set(this.roams)
		}
	}
}
